import { useCallback, useState } from 'react'

type Updater<T> = (prevState: T) => T
type SetStateAction<T> = T | Updater<T>

export default function useSiteStateProvider() {
  const [items, setItems] = useState<Record<string, any>>({})

  const setSiteStateItem = useCallback(
    <T>(key: string, setStateAction: SetStateAction<T>) => {
      const isUpdater = (input: unknown): input is Updater<T> =>
        typeof input === 'function'

      setItems((oldItems) => ({
        ...oldItems,
        [key]: isUpdater(setStateAction)
          ? setStateAction(oldItems[key])
          : setStateAction
      }))
    },
    [setItems]
  )

  return {
    items,
    setSiteStateItem
  }
}
